import type { SupplyProgram } from '@shared/types';
import { PROGRAM_LABELS } from '@shared/types';

/**
 * Which program an order belongs to.
 *
 * Deliberately neutral in colour: this app already spends its palette on order
 * *status* (amber = submitted, green = delivered, red = cancelled), and a
 * coloured program pill next to a coloured status would read as a second
 * severity. The word carries the meaning.
 */
export default function ProgramBadge({ program, className = '' }: { program: SupplyProgram; className?: string }) {
  return (
    <span
      className={`inline-block shrink-0 rounded-full bg-white/10 px-2 py-0.5 text-xs font-medium text-zinc-300 ${className}`}
    >
      {PROGRAM_LABELS[program]}
    </span>
  );
}
